import {useApp} from '../../../contexts/AppContext';
import {useAuth} from '../../../contexts/UserContext';
import {useEffect, useState, useRef, useMemo} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {PageMainTitle} from '../../atoms/CommonParts';
import './style.scss';
import {getMyRoomsForDashboard, getVenueReport} from '../../../api';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import SelectModal, {SelectedLabel} from '../../organisms/SelectModal';
import SimpleBar from 'simplebar-react';
import VenueReportGraph from './VenueReportGraph';

const Page = styled.div`
  @media ${config.layout.wide} {
  }
`;

const WARNING_LIMIT_DAYS = 7;

const MONTHS = [...(new Array(12))].map((_, i) => {
  let d = new Date('2000-01-15');
  d.setMonth(i);
  return {
    month: i + 1,
    label: moment(d).format('MMM').toUpperCase(),
  };
});

const PoweredBy = styled.div`
  position: absolute;
  right: 0;
  bottom: 20px;
  display: flex;
  align-items: flex-end;

  .label {
    font-size: 10px;
    font-weight: bold;
    margin-right: 8px;
    position: relative;
    top: -1px;
  }

  a {
    display: block;
    width: 52px;
    height: 33px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: image-set(url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAhCAMAAAChvXjxAAAAQlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACO4fbyAAAAFXRSTlMAQIDAMPBvIGCgsE8Q0N+Q4Fg/rz19hEUbAAABh0lEQVQ4y62Si27dIBBEd3k/DHbTnv//1a7ta1WpooZUGSENg3UEhpEPtZWfE/yeZV09AsN7H+u2ylSIzjaxEVJYYxz4Le8TmHtegxSqJB6lJcgzZAea09SAfYHJEDqM+1hhQP8cSjQ5iNtz+ZG5cg2lQxFpsZy5QF+AQiXaJMLQy+sCJB5vE05VudJn6u+gYw3ayI35gpqV4qAtlKgUUJFx/5IuvW9uW2SIhPJ6a1ZKq+rgVe+trlXibLeHmYJ1fAJV1rQ1/ijKqsrBqVEqFFlW1qTh9L3Kf2iTb1MgpPivzz32v5aSS6gmO31xfbP4dq2mYKbOLLsf+PIKZioF4II0AvPu9g6wSwVIJwTiAYoMvMSh6rAhLaoWvOrOL5pqI1BPUxI1KE71mB2XBWcbXpD3Iq+YTnNmetqd9Q7uNPYPoHJD5YHKA9Ub8tH7GfN7SKOtxkMfyHLNTFtrF5QbjC4G1WZQTHZzMQQPPtjEChUDlg/pA9rWY36u/W0e8lUB/euV0Cxf0G80JxmLTqE3jgAAAABJRU5ErkJggg==') 1x, url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABCCAMAAACM9WPDAAAAgVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABtFS1lAAAAKnRSTlMAgEDA8BCgv1AwcCDPsOBgkN8/f6+ONxpeJ9ELuJVmU0rz8ufKqHYTBZluIP9uAAADrElEQVRYw7TV626DMAwF4AMkGeFOWaH3dvfN7/+AI4aMlmqTprrfLyQkDnacBP/ysXp7rRWp+nUfb3E3p4jOPa5xFzaiOdNB3juNnh/fD8fweGh2T/R8grQvGuxDTFpDCWTtiJkUzC4WFk63rCCpIuelRS82ipgyscssIWdFzqYDkCg6oxpIWpOz2wJxTTN1DDk517MFEromOA4t9Z5SwNBIRb2CRgZCHqh3AoIxpbJgtlLEAojoqJcDJbE8xY80J1ZCwoF6a2h1vSI+XWmpUTBAMP37dVIFAa6SFik55re9nOJmn+5IAJKpRWlNJoWnC5l54FL2QDY1jieg0RfNy2R20XHsnIYTkVOvfEkyvePzZ4FwmHEfxB5CTBWGuNUHDzf3J/BB3hJOIHQQccuC6yBfo393s80fQYqnQShoSbT+LaiSrCgkahHyZ2dBKoBTCQVBUTkE1ZdBRoPVAlPHGjIurWfPgiL/aUsOBGxVDRh/1A2PRQmP3+SQkFCLmH4apPMo0MBFQTEkfEZvQMGrpDGjeYUKyNCbDiE52SxJZ2JXLOuMn4HM4owdcjKI6RZ88VxeELpRNNCQZL/bMbPc1mEYilISpWjwFMcFsgbvf4HPl09D6g4pgrhAi96PJDQpHVkjlVLtcp1DmK/LWjXSAaSdntt3beg/UKIna9y9FPclh3y2rOoaZlCWkgL7TAcoxclscjFkdhywZ3yLRuPomxToT8fLM3ssSfdw6XT+0npSOCf1g6cySqutsPlaqKH06CEW1zXeA4XLSSRhSVuCosOjS8heF0nkX2C9eBKNTiyN31qjO3gzZQ0vUjzl42Q5hdvtS0AzQKnuM65u0CjUF2tB+dNtDh4CQBBROGcHj2gCAEq8DZT+b1vm/aNANWsCtUrlroMYeUSVzpffiDoHtWkCSLAknw4PhzV78WLeIgQW2mEDsixYHSqXySDBAdB1goe3CHhYjZa45EqugVQZVX2bNaIirncvPeIlixVuZ50r2bNH/5h8p6nprHoFUvXOspu+BatVtVBF8ZdG1XZK7O8EMb5Lz94FnUnEH4F4P0ZcQPju/DzPEXPwc5DFApo3LZh1b0Ek/oRYvm5h+HevzyBQq9h+DqKpxTragaqfsXKqdAW10hzoDqilW53dg5qfyFdSpAYi38NvXKIC8sPgSdTnm09+ZKPZ6hhMtMi7yyVp4r75DYYnOYPW9CAo7tK7mzDT0fKXi5PeP1q8QpzoaA3C0XS4vFIqWvrp+gdDINEKFHFWFQAAAABJRU5ErkJggg==') 2x);
`;

const CareStatusArea = styled.div`
  a {
    text-decoration: none;
    color: #000000;
  }

  margin-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #000000;

  .care-status-label {
    display: inline-block;
    width: 100%;
    background-color: #F8F8F8;
    height: 29px;
    border: 1px solid #000000;
    line-height: 27px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 14px;
    padding-left: 32px;
    transition: background-color 0.15s linear, color 0.15s linear;
    @media ${config.layout.wide} {
      width: 350px;
      @media (hover: hover) {
        &:hover {
          background-color: #000000;
          color: #ffffff;
        }
      }
    }
    position: relative;

    &:before {
      content: '';
      width: 20px;
      height: 20px;
      display: block;
      border-radius: 50%;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -10px;
      background-repeat: no-repeat;
      background-size: contain;
      background-color: #ffffff;
      transition: background-image 0.15s linear;
    }

    &:after {
      content: '';
      width: 6px;
      height: 10px;
      display: block;
      right: 10px;
      top: 50%;
      position: absolute;
      margin-top: -5px;
      background-repeat: no-repeat;
      background-size: contain;
      transition: background-image 0.15s linear;
    }
  }
`;

const WarningsArea = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #000;

  div {
    display: flex;
    position: relative;
    align-items: flex-start;
    margin-top: 20px;
    gap: 10px;

    span {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      flex: 1 1 auto;
    }

    &:before {
      position: relative;
      top: -3px;
      flex: 0 0 auto;
      content: '';
      display: block;
      width: 24px;
      height: 24px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml,<%3Fxml version="1.0" encoding="utf-8"%3F><svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><style type="text/css">.st0{enable-background:new ;}.st1{fill:%23FFFFFF;}</style><circle id="楕円形_67" cx="12" cy="12" r="11.9"/><g class="st0"><path class="st1" d="M11.996,16.46c0.428,0,0.772,0.126,1.032,0.378c0.262,0.252,0.392,0.574,0.392,0.967c0,0.387-0.13,0.706-0.392,0.958c-0.26,0.252-0.604,0.378-1.032,0.378c-0.422,0-0.763-0.126-1.024-0.378s-0.391-0.571-0.391-0.958s0.13-0.707,0.391-0.963C11.232,16.588,11.574,16.46,11.996,16.46z M13.05,15.071h-2.109l-0.299-8.868h2.707L13.05,15.071z"/></g></svg>');
    }
  }
`;

const PeriodWrap = styled.div`
  position: relative;
`;

const PeriodContents = styled.div`
  padding-top: 44px;

  .chart-button {
    margin-top: 30px;
    border-radius: 2px;
    overflow: hidden;
    @media ${config.layout.wide} {
      margin-top: 20px;

    }
  }
`;

const SummaryContents = styled.div`

  & > * {
    &:first-child {
      margin-bottom: 20px;
    }
  }

  @media ${config.layout.wide} {
    display: flex;
    gap: 30px;
    align-items: flex-start;

    & > * {
      width: calc((100% - 30px) / 2);
      flex: 0 0 auto;

      &:first-child {
        margin-bottom: 0;
      }
    }
  }
`;

const SummaryDataSectionWrap = styled.div`
  border: 1px solid #000000;
  border-radius: 2px;
`;

const SummaryDataItemSectionWrap = styled.div`
  &:first-child {
    border-bottom: 1px solid #000000;
  }

  padding: 23px 24px;
  position: relative;

  .LabelWithInfo {
    h4 {
      & > span {
        font-size: 20px;
        line-height: 26px;
      }
    }
  }
`;

const SummaryDataItemValue = styled.div`
  text-align: center;
  font-size: 60px;
  line-height: 70px;
  font-weight: bold;
`;

const SummaryDataItemValueSuffix = styled.div`
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:before {
    content: '';
    display: block;
    width: 20px;
    height: 1px;
    background-color: #000000;
  }

  &:after {
    content: '';
    display: block;
    width: 20px;
    height: 1px;
    background-color: #000000;
  }
`;

const SummaryDataItemRatioElm = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  height: 38px;
  border-left: 1px solid #000000;
  border-bottom: 1px solid #000000;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0 16px 8px;

  div {
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }

  &:after {
    content: '%';
    font-size: 12px;
    font-weight: bold;
    margin-left: 3px;
    line-height: 15px;
  }

  &:before {
    content: '▲';
    font-size: 14px;
    font-weight: bold;
    margin-right: 5px;
    line-height: 17px;
    color: #007CE0;
  }

  &.negative {
    &:before {
      content: '▲';
      transform: rotateZ(180deg);
      line-height: 20px;
      color: #A5A5A5;
    }
  }
`;

function SummaryDataItemSection({
  data,
  labelInfoElm,
  suffix,
}) {

  let ratio = 0;
  if (data?.previous?.numerator) {
    ratio = Math.floor(
        (data.current.numerator / data.previous.numerator - 1.0) * 100);
  }

  return (
      <SummaryDataItemSectionWrap>
        {labelInfoElm}
        <SummaryDataItemValue>{(data?.current?.numerator ||
            0).toLocaleString()}</SummaryDataItemValue>
        <SummaryDataItemValueSuffix>
          <div>{suffix}</div>
        </SummaryDataItemValueSuffix>
        <SummaryDataItemRatioElm
            className={ratio >= 0 ? 'positive' : 'negative'}
        >
          <div>{Math.abs(ratio)}</div>
        </SummaryDataItemRatioElm>
      </SummaryDataItemSectionWrap>
  );
}

function SummaryDataSection({
  tracks,
  artists,
}) {

  if (!tracks?.current?.numerator) {
    return (<NoData/>);
  }

  return (
      <SummaryDataSectionWrap>
        <SummaryDataItemSection
            data={tracks}
            labelInfoElm={(
                <LabelWithInfo
                    text={'Period total'}
                    style={{
                      marginTop: 0,
                      marginBottom: 23,
                    }}
                >
                  <div>
                    The total number of tracks played in the selected period.
                  </div>
                </LabelWithInfo>
            )}
            suffix={'tracks'}
        />
        <SummaryDataItemSection
            data={artists}
            labelInfoElm={(
                <LabelWithInfo
                    text={'Period total'}
                    style={{
                      marginTop: 0,
                      marginBottom: 20,
                    }}
                >
                  <div>
                    The total number of artists played in the selected period.
                  </div>
                </LabelWithInfo>
            )}
            suffix={'artists'}
        />
      </SummaryDataSectionWrap>
  );
}

const SummaryDevicesSectionWrap = styled.div`
  border: 1px solid #000000;
  border-radius: 2px;
  position: relative;
`;

const SummaryDevicesSectionContents = styled.div`
  padding: 30px 20px;

  table {
    width: 100%;
    margin-top: 40px;

    thead {
      tr {
        border-bottom: 1px solid #000000;

        th {
          font-size: 12px;
          font-weight: bold;
          padding-bottom: 10px;

          &:last-child {
            text-align: right;
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #000000;

        &:nth-child(2n + 1) {
          background-color: #F8F8F8;
        }

        th {
          height: 49px;
          vertical-align: middle;
          border-right: 1px solid #000000;
          padding-left: 10px;
          font-size: 14px;
          font-weight: bold;
          padding-right: 10px;
          white-space: nowrap;
        }

        td {
          height: 49px;
          vertical-align: middle;
          padding-left: 10px;
          padding-right: 10px;
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          width: 100%;
        }
      }
    }
  }
`;

const SummaryDevicesSectionTotalLabel = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
  margin-left: 4px;
`;

const SummaryDevicesSectionTotalValue = styled.div`
  margin-top: 20px;
  font-weight: bold;
  line-height: 70px;
  font-size: 60px;
  text-align: center;
`;

function SummaryDevicesSection({
  room_devices,
}) {

  const [selectedRoomID, setSelectedRoomID] = useState(0);

  useEffect(() => {
    if (!room_devices?.length) {
      setSelectedRoomID(0);
    } else {
      setSelectedRoomID(room_devices[0].id);
    }
  }, [room_devices]);

  const onRoomSelected = (newRoomID) => {
    setSelectedRoomID(newRoomID);
  };

  if (!room_devices?.length) {
    return (<NoData/>);
  }

  if (!selectedRoomID) {
    return '';
  }

  const devices = room_devices.find(d => d.id === selectedRoomID)?.devices ||
      [];
  //console.log(devices);
  let total = devices.reduce((p, c, i) => {
    return p + c.value;
  }, 0);

  return (<SummaryDevicesSectionWrap>
    <LatestChartRoomSelector
        onRoomSelected={onRoomSelected}
        selectedRoomID={selectedRoomID}
        rooms={room_devices.map(d => {
          if (d.type === 'room') {
            return {
              id: d.id,
              name: d.room.name || '',
            };
          } else if (d.type === 'device') {
            return {
              id: d.id,
              name: d.device?.device_name || '',
            };
          } else {
            return null;
          }
        }).filter(v => !!v)}/>
    <SummaryDevicesSectionContents>
      <SummaryDevicesSectionTotalLabel>Activity per room
      </SummaryDevicesSectionTotalLabel>
      <SummaryDevicesSectionTotalValue>{total.toLocaleString()}</SummaryDevicesSectionTotalValue>
      <SummaryDataItemValueSuffix>
        <div>tracks</div>
      </SummaryDataItemValueSuffix>
    </SummaryDevicesSectionContents>
  </SummaryDevicesSectionWrap>);
}

function Summary({
  tracks,
  artists,
  room_devices,
}) {

  return (
      <>
        <LabelWithInfo
            text={'Venue summary'}
            style={{
              marginTop: 40,
              marginBottom: 20,
            }}
        >
          <div>
            Overview of the latest month's activity at your venue. Tailor your
            insights by selecting a specific month from the Period menu.
          </div>
        </LabelWithInfo>
        <SummaryContents>
          <SummaryDataSection
              tracks={tracks}
              artists={artists}/>
          <SummaryDevicesSection
              room_devices={room_devices}/>
        </SummaryContents>
      </>
  );
}

function PeriodGraph({
  data,
  fetchedYM,
}) {

  return (<>
    <LabelWithInfo
        text={'Played (Room/Floor)'}
        style={{
          marginTop: 40,
          marginBottom: 20,
        }}
    >
      <div>
        The interactive graph unveils daily activity trends over the past month.
        Use the top menu to customize your view by selecting the month,
        room/floor, and tracks/hours.
      </div>
    </LabelWithInfo>
    {
      data?.tracks?.length ? (
          <VenueReportGraph
              room_graphs={data}
              year={Math.floor(fetchedYM / 100)}
              month={fetchedYM % 100}
              rooms={data.tracks.length ? data.tracks.map(d => {

                if (d.type === 'room') {
                  return {
                    id: d.id,
                    name: d.room.name || '',
                  };
                } else if (d.type === 'device') {
                  return {
                    id: d.id,
                    name: d.device?.device_name || '',
                  };
                } else {
                  return {
                    id: 0,
                    name: 'Total',
                  };
                }
              }) : [
                {
                  id: 0,
                  name: 'Total',
                }]}
          />
      ) : (
          <NoData/>
      )
    }
  </>);
}

const LatestChartElm = styled.div`
  min-height: 160px;
  border-radius: 2px;
  border: 1px solid #000000;
  position: relative;
  @media ${config.layout.wide} {
    border-radius: 2px 0 2px 2px;
  }
`;

const LatestChartRoomSelectorWrap = styled.div`
  overflow-x: scroll;
  @media ${config.layout.wide} {
    overflow-x: hidden;
    position: relative;
    height: 44px;
  }
`;

const LatestChartRoomSelectorItems = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  gap: 1px;

  @media ${config.layout.wide} {
    position: absolute;
    transition: left 0.15s ease-out;
  }
`;

const LatestChartRoomSelectorItem = styled.div`
  min-width: 80px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  font-size: 14px;
  color: #ffffff;
  background-color: #000000;
  font-weight: bold;

  cursor: pointer;
  white-space: nowrap;
  padding: 0 20px;
  flex: 0 0 auto;

  &.active {
    color: #000000;
    background-color: transparent;
  }

  &.in_touch {
    color: #000000;
    background-color: #ffffff;
  }

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    @media (hover: hover) {
      &:hover {
        color: #000000;
        background-color: #ffffff;
      }
    }
  }
`;

const LatestChartRoomSelectorControls = styled.div`
  position: absolute;
  right: -40px;
  top: -1px;
  display: none;
  @media ${config.layout.wide} {
    display: block;
  }
`;

const LatestChartRoomSelectorControl = styled.button`
  display: block;
  width: 40px;
  height: 30px;
  border-radius: 0;
  background-color: #000000;
  margin-bottom: 1px;
  position: relative;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center;

    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path  d="M4.445,5,0,.744.777,0,6,5,.777,10,0,9.256Z" fill="%23fff"/></svg>');
  }

  &.prev {
    &:before {
      transform: rotateZ(180deg);
    }
  }

  &.disabled {
    opacity: 0.1;
    cursor: default;
  }

  &:not(.disabled) {
    &.in_touch {
      background-color: #fff;

      &:before {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path  d="M4.445,5,0,.744.777,0,6,5,.777,10,0,9.256Z" fill="%23000"/></svg>');
      }
    }

    @media (hover: hover) {
      &:hover {
        background-color: #fff;

        &:before {
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path  d="M4.445,5,0,.744.777,0,6,5,.777,10,0,9.256Z" fill="%23000"/></svg>');
        }
      }
    }
  }
`;

function LatestChartRoomSelector({
  selectedRoomID,
  rooms,
  onRoomSelected,
}) {
  const updateScrollTimerRef = useRef(null);
  const wrapRef = useRef();
  const itemsRef = useRef();
  const [detached, setDetached] = useState(false);

  useEffect(() => {
    let cb = () => {
      updatePos();
    };
    window.addEventListener('resize', cb);
    cb();
    return () => {
      //setDetached(true);
      window.removeEventListener('resize', cb);
    };
  }, []);

  useEffect(() => {
    updatePos();
  }, [selectedRoomID, rooms]);

  const updatePos = () => {
    if (detached) {
      return;
    }
    if (updateScrollTimerRef.current) {
      clearTimeout(updateScrollTimerRef.current);
      updateScrollTimerRef.current = null;
    }
    updateScrollTimerRef.current = setTimeout(() => {
      if (detached) {
        return;
      }
      updatePosCore();
    }, 100);
  };

  const updatePosCore = () => {
    if (detached ||
        !wrapRef.current ||
        window.isSP() ||
        !itemsRef.current
    ) {
      if (itemsRef.current) {
        itemsRef.current.style.left = '0px';
      }
      return;
    }
    if (updateScrollTimerRef.current) {
      clearTimeout(updateScrollTimerRef.current);
      updateScrollTimerRef.current = null;
    }

    let wrapWidth = wrapRef.current.clientWidth;
    let currentLeft = parseInt(itemsRef.current.style.left || '0', 10);
    let tabs = [...itemsRef.current.children];

    const {left, right} = tabs.reduce((p, c, i) => {
      let id = parseInt(c.getAttribute('data-id'), 10);
      if (p.found) {
        return p;
      }
      if (id === selectedRoomID) {
        p.right = p.left + c.clientWidth;
        p.found = true;
        return p;
      }
      p.left += c.clientWidth + 1;
      return p;
    }, {left: 0, right: 0, found: false});
    if (!left && !right) {
      return;
    }
    if (currentLeft + left < 0) {
      itemsRef.current.style.left = `${-1 * left}px`;
    } else if (currentLeft + right > wrapWidth) {
      itemsRef.current.style.left = `${-1 * (right - wrapWidth)}px`;
    }
  };

  const currentPos = useMemo(() => {
    return Math.min(Math.max(0,
        rooms.findIndex(r => r.id === selectedRoomID)), rooms.length - 1);
  }, [selectedRoomID, rooms]);

  const onNextClicked = () => {
    if (currentPos < (rooms.length - 1)) {
      onRoomSelected(rooms[currentPos + 1].id);
    }
  };

  const onPrevClicked = () => {
    if (currentPos > 0) {
      onRoomSelected(rooms[currentPos - 1].id);
    }
  };

  return (
      <>
        <LatestChartRoomSelectorControls>
          <LatestChartRoomSelectorControl
              className={`in_touch_target next ${currentPos < rooms.length - 1
                  ? ''
                  : 'disabled'}`}
              onClick={onNextClicked}/>
          <LatestChartRoomSelectorControl
              className={`in_touch_target prev ${currentPos === 0
                  ? 'disabled'
                  : ''}`}
              onClick={onPrevClicked}/>
        </LatestChartRoomSelectorControls>
        <LatestChartRoomSelectorWrap ref={wrapRef}>
          <LatestChartRoomSelectorItems ref={itemsRef}>
            {
              rooms.map((r, i) => {
                return (
                    <LatestChartRoomSelectorItem key={i}
                                                 data-id={r.id}
                                                 className={`in_touch_target ${r.id ===
                                                 selectedRoomID
                                                     ? 'active'
                                                     : ''} item-${r.id}}`}
                                                 onClick={() => {
                                                   onRoomSelected(r.id);
                                                 }}
                    >{r.name}</LatestChartRoomSelectorItem>
                );
              })
            }
          </LatestChartRoomSelectorItems>
        </LatestChartRoomSelectorWrap>
      </>
  );
}

const NoData = styled.div`
  border: 1px solid #000000;
  border-radius: 2px;
  height: 166px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: 'No data available';
    font-weight: bold;
    font-size: 20px;
  }
`;

const PeriodSectionWrap = styled.div`
  padding-bottom: 40px;

  .note {
    font-size: 14px;
    line-height: 19px;
    margin-top: 20px;
    font-weight: bold;
  }
`;

function PeriodSection() {
  const {state} = useApp();
  const [fetchedYM, setFetchedYM] = useState(0);
  const [data, setData] = useState(null);

  useEffect(() => {
    let newYM = state.dashboard_period.year * 100 +
        state.dashboard_period.month;
    if (newYM === fetchedYM && data) {
      return;
    }
    updateData(state.dashboard_period);
  }, [state.dashboard_period]);

  const updateData = async ({year, month}) => {

    let now = new Date();

    let _data = await getVenueReport({
      year,
      month,
      previous_month_date_limit: (
          now.getFullYear() === year &&
          (now.getMonth() + 1) === month ?
              now.getDate() : 0
      ),
    });
    console.log(year, month, _data);
    setFetchedYM(year * 100 + month);
    setData(_data);
  };

  if (!fetchedYM) {
    return '';
  }

  return (
      <PeriodSectionWrap>
        <div className={'note'}>For accurate data, please ensure all devices are
          registered and operational. Missing data? Check the <Link
              to={`/devices/`}
              style={{color: '#000'}}
          >
            <span
            >Device menu.</span>
          </Link>
        </div>
        <LabelWithInfo
            text={'Period'}
            style={{
              marginTop: 40,
              marginBottom: 20,
            }}
        >
          <div>
            Select the report term to display.
          </div>
        </LabelWithInfo>
        <PeriodWrap>
          <PeriodSelectorArea>
            <PeriodSelector/>
          </PeriodSelectorArea>
          <PeriodContents>

            <PeriodGraph data={data?.room_graphs || null}
                         fetchedYM={fetchedYM}/>

            <Link
                className="dark-button center-fixed chart-button in_touch_target"
                to={`/chart`}
            >
              <span>Top 50 most played</span>
            </Link>

            <Summary tracks={data?.tracks || []}
                     artists={data?.artists || []}
                     room_devices={data?.room_devices || []}
            />

          </PeriodContents>
        </PeriodWrap>
      </PeriodSectionWrap>
  );
}

const PeriodSelectorArea = styled.div`
  height: calc(100% - 200px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  pointer-events: none;

  @media ${config.layout.wide} {
    height: calc(100% - 300px);

  }
`;

const PeriodSelectorWrap = styled.div`
  pointer-events: initial;
  width: 100%;
  height: 44px;
  position: sticky;
  top: 0;
  bottom: 500px;
  z-index: 5;

  & > div {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    gap: 1px;
    width: calc(100% + 40px);
    position: relative;
    left: -20px;
    justify-content: space-between;
    @media ${config.layout.wide} {
      width: 390px;
      left: 0;

    }
  }
`;

const PeriodMoveButton = styled.button`
  display: block;
  width: 55px;
  height: 44px;
  border-left: none;
  border-right: none;
  background-color: #000000;
  flex: 0 0 auto;
  position: relative;

  &:before {
    content: '';
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path d="M1.555,5,6,.744,5.223,0,0,5l5.223,5L6,9.256Z" fill="%23fff"/></svg>');
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;;
  }

  &[disabled] {
    opacity: 0.5;
  }

  &.next {
    &:before {
      transform: rotateZ(180deg);
    }
  }

  &.in_touch {
    &:not([disabled]) {
      background-color: #fff;

      &:before {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path d="M1.555,5,6,.744,5.223,0,0,5l5.223,5L6,9.256Z" fill="%23000"/></svg>');
      }
    }
  }

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear;
    &:not([disabled]) {
      @media (hover: hover) {
        &:hover {
          background-color: #fff;

          &:before {
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path d="M1.555,5,6,.744,5.223,0,0,5l5.223,5L6,9.256Z" fill="%23000"/></svg>');
          }
        }
      }
    }
  }
`;

const PeriodSelectedLabel = styled.div`
  text-align: center;
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  height: 44px;
  line-height: 42px;
  font-size: 14px;
  font-weight: bold;
  cursor: default;
  position: relative;
  background-color: #000000;
  color: #ffffff;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 35px 0 20px;
  flex: 1 1 calc((100% - 55px - 1px - 55px - 1px - 1px) / 2);
  width: calc((100% - 55px - 1px - 55px - 1px - 1px) / 2);

  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 11px;
    height: 8px;
    border-top: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    right: 15px;
    top: 50%;
    margin-top: -4px;
  }

  &.in_touch {
    background-color: #ffffff;
    color: #000000;

    &::after {
      border-color: #000000;
    }
  }

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    @media (hover: hover) {
      &:hover {
        background-color: #ffffff;
        color: #000000;

        &::after {
          border-color: #000000;
        }
      }
    }
  }

`;

function YearSelect({year, onSelectYear}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const nowYear = (new Date()).getFullYear();
  const years = [...new Array(nowYear - 2017 + 1)].map((_, i) => i + 2017);
  years.reverse();
  let selectedIndex = years.findIndex(y => y === year);

  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    onSelectYear && onSelectYear(years[index]);
  };

  return (
      <>
        <PeriodSelectedLabel onClick={onClick}
                             className={'reverse in_touch_target'}
        >{year}</PeriodSelectedLabel>
        <SelectModal
            title="Year"
            candidates={years.map(y => y.toString())}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
      </>
  );
}

function MonthSelect({month, onSelectMonth}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  let selectedIndex = MONTHS.findIndex(m => m.month === month);
  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    onSelectMonth && onSelectMonth(MONTHS[index].month);
  };

  return (
      <>
        <PeriodSelectedLabel onClick={onClick}
                             className={'reverse in_touch_target'}
        >{MONTHS[selectedIndex].label}</PeriodSelectedLabel>
        <SelectModal
            title="Month"
            candidates={MONTHS.map(m => m.label)}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
      </>
  );
}

function PeriodSelector() {
  const {state, dispatch} = useApp();
  const timer = useRef(null);
  const [tempYear, setTempYear] = useState(state.dashboard_period.year);
  const [tempMonth, setTempMonth] = useState(state.dashboard_period.month);
  const [prevEnabled, setPrevEnabled] = useState(false);
  const [nextEnabled, setNextEnabled] = useState(false);
  const onSelectYear = (year) => {
    setTempYear(year);
  };

  const onSelectMonth = (month) => {
    setTempMonth(month);
  };

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    timer.current = setTimeout(updateCore, 1500);

    setPrevEnabled(tempYear !== 2017 || tempMonth !== 1);
    let now = new Date();
    let currentYM = now.getFullYear() * 100 + (now.getMonth() + 1);
    let newYM = tempYear * 100 + tempMonth;
    setNextEnabled(newYM < currentYM);

  }, [tempYear, tempMonth]);

  const updateCore = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    dispatch({
      type: 'set_dashboard_period',
      dashboard_period: {
        year: tempYear,
        month: tempMonth,
      },
    });
  };

  const onPrevClick = () => {
    if (tempMonth === 1) {
      setTempMonth(12);
      setTempYear(tempYear - 1);
    } else {
      setTempMonth(tempMonth - 1);
    }
  };

  const onNextClick = () => {
    if (tempMonth === 12) {
      setTempMonth(1);
      setTempYear(tempYear + 1);
    } else {
      setTempMonth(tempMonth + 1);
    }
  };

  return (
      <PeriodSelectorWrap>
        <div>
          <YearSelect year={tempYear} onSelectYear={onSelectYear}/>
          <MonthSelect month={tempMonth} onSelectMonth={onSelectMonth}/>
          <PeriodMoveButton className={'in_touch_target prev'}
                            onClick={onPrevClick}
                            disabled={!prevEnabled}/>
          <PeriodMoveButton className={'in_touch_target next'}
                            onClick={onNextClick}
                            disabled={!nextEnabled}/>
        </div>
      </PeriodSelectorWrap>
  );
}

const LastConnectionSectionWrap = styled.div`
  background-color: #F8F8F8;
  position: relative;

  display: none;
  
  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 100vw;
    left: -20px;
    height: calc(100% + 100px);
    @media ${config.layout.wide} {
      width: calc(100vw - var(--scwidth));
      left: calc(50% - (100vw - var(--scwidth)) / 2);
    }
    background-color: #F8F8F8;

  }
`;

const LastConnectionBlockWrap = styled.div`
  border: 1px solid #000000;
  border-radius: 2px;
  position: relative;
  background-color: #ffffff;
`;

const LastConnectionBlockContents = styled.div`
  padding: 30px 20px;

  table {
    width: 100%;
    margin-top: 30px;

    thead {
      tr {
        border-bottom: 1px solid #000000;

        th {
          font-size: 12px;
          font-weight: bold;
          padding-bottom: 10px;

          &:last-child {
            text-align: right;
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #000000;

        &:nth-child(2n + 1) {
          background-color: #F8F8F8;
        }

        th {
          height: 49px;
          vertical-align: middle;
          border-right: 1px solid #000000;
          padding-left: 10px;
          font-size: 14px;
          font-weight: bold;
          padding-right: 10px;
          white-space: nowrap;
        }

        td {
          height: 49px;
          vertical-align: middle;
          padding-left: 10px;
          padding-right: 10px;
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          width: 100%;
        }
      }
    }
  }
`;

const LastConnectionSectionInner = styled.div`
  position: relative;
  padding: 40px 0 0;

  @media ${config.layout.wide} {
    width: 350px;
    margin: 0 auto;
  }
`;

function LastConnectionSection({
  rooms,
}) {
  const [displayRooms, setDisplayRooms] = useState([]);
  const [selectedRoomID, setSelectedRoomID] = useState(0);

  useEffect(() => {
    let _rooms = rooms.filter(r => r.devices.length);
    //_rooms = [];
    if (!_rooms.length) {
      setSelectedRoomID(0);
    } else {
      setSelectedRoomID(_rooms[0].room_id);
    }
    setDisplayRooms(_rooms);
  }, [rooms]);

  const onRoomSelected = (newRoomID) => {
    setSelectedRoomID(newRoomID);
  };

  const devices = useMemo(() => {
    if (!selectedRoomID) {
      return [];
    }
    const devices = displayRooms.find(
        d => d.room_id === selectedRoomID).devices || [];
    devices.sort((a, b) => a.device_name.localeCompare(b.device_name));

    devices.forEach(d => {
      let o = (d.last_online_time && (new Date(d.last_online_time))) ||
          null;
      if (!o || !o.getTime()) {
        d.last_online_time_ms = 0;
      } else {
        d.last_online_time_ms = o.getTime();
      }
    });

    const reducedDevices = devices.reduce((p, c) => {
      let l = p.length;
      if (!l) {
        p.push(c);
        return p;
      }
      let last = p[l - 1];
      if (last.device_name !== c.device_name) {
        p.push(c);
        return p;
      }
      if (last.last_online_time_ms >= c.last_online_time_ms) {
        return p;
      }
      p.pop();
      p.push(c);
      return p;
    }, []);

    reducedDevices.forEach(d => {
      if (!d.last_online_time_ms) {
        d.last_online_time_str = 'Never';
      } else {
        d.last_online_time_str = moment(new Date(d.last_online_time_ms)).
            format('YYYY/MM/DD');
      }
    });

    return reducedDevices;
  }, [displayRooms, selectedRoomID]);

  if (!selectedRoomID) {
    return '';
  }

  return (
      <LastConnectionSectionWrap>
        <LastConnectionSectionInner>
          <LabelWithInfo
              text={'Last connection'}
              style={{
                marginTop: 0,
                marginBottom: 15,
              }}
          >
            <div>
              The Last connection shows the most recent reported date from the
              registered devices. Open the Device menu to manage your device and
              linked room/floor.
            </div>
          </LabelWithInfo>
          <LastConnectionBlockWrap>
            <LatestChartRoomSelector
                onRoomSelected={onRoomSelected}
                selectedRoomID={selectedRoomID}
                rooms={displayRooms.map(d => {
                  return {
                    id: d.room_id,
                    name: d.name,
                  };
                }).filter(v => !!v)}/>
            <LastConnectionBlockContents>
              <table>
                <thead>
                <tr>
                  <th>Device</th>
                  <th>Last connection</th>
                </tr>
                </thead>
                <tbody>
                {devices.map((d, i) => {
                  return (
                      <tr
                          key={i}
                      >
                        <th>{d.device_name}</th>
                        <td>{d.last_online_time_str}</td>
                      </tr>
                  );
                })}
                </tbody>
              </table>
            </LastConnectionBlockContents>
          </LastConnectionBlockWrap>

        </LastConnectionSectionInner>
      </LastConnectionSectionWrap>
  );
}

export default function HomePage() {
  const app = useApp();
  const {state} = useAuth();
  const [detached, setDetached] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [warnings, setWarnings] = useState([]);
  // -1: 非対称国, 0:利用不可, 1:利用可能
  const [careStatus, setCareStatus] = useState(-1);

  useEffect(() => {
    app.showHeader();
    document.title = 'Dashboard';

    return () => {
      setDetached(true);
    };
  }, []);

  useEffect(() => {
    if (detached) {
      return;
    }

    //state.venue.care.status = 0;
    //state.venue.care.is_target_country = 1;

    if (state.venue?.care?.is_target_country) {
      if (state.venue.care.status) {
        setCareStatus(1);
      } else {
        setCareStatus(0);
      }
    } else {
      setCareStatus(-1);
    }

    updateRooms();
  }, [state]);

  const updateRooms = async () => {
    if (detached) {
      return;
    }
    let roomsData = await getMyRoomsForDashboard();
    if (detached) {
      return;
    }
    setRooms(roomsData);
  };

  useEffect(() => {
    if (detached) {
      return;
    }
    if (!rooms.length) {
      setWarnings([]);
    } else {
      let now = Date.now();
      let warns = [];
      rooms.forEach(room => {
        let last_play_datetime = room.last_play_datetime &&
            (new Date(room.last_play_datetime)).getTime() || 0;
        let offlineDays = Math.floor(
            (now - last_play_datetime) / 1000 / 3600 / 24);
        if (!last_play_datetime || (3600 * 24 * 100) > last_play_datetime) {
          warns.push(`${room.name} hasn’t exported tracks.`);
        } else if (offlineDays >= WARNING_LIMIT_DAYS) {
          warns.push(
              `${room.name} hasn’t exported tracks for more than ${offlineDays} days.`);
        }
      });
      setWarnings(warns);
      console.log(rooms);
    }
  }, [rooms]);

  return (
      <Page>
        <PageMainTitle>
          <span>Dashboard</span>
          <PoweredBy>
            <div className={'label'}>Powered by</div>
            <Link to={'/care/about/'} style={{
              pointerEvents: 'none',
            }}></Link>
          </PoweredBy>
        </PageMainTitle>
        {
          careStatus >= 0 ? (
              <CareStatusArea>
                <Link to={'/care/about/'}>
                  {
                    careStatus === 1 ? (
                        <span className={'care-status-label enabled'}>Your venue is eligible for KUVO Care</span>
                    ) : (
                        <span className={'care-status-label disabled'}>Your venue is currently ineligible for KUVO Care</span>
                    )
                  }
                </Link>
              </CareStatusArea>
          ) : ''
        }
        {
          warnings.length ? (
              <WarningsArea>
                {
                  warnings.map((w, i) => {
                    return (
                        <div
                            key={i}
                        ><span>{w}</span></div>
                    );
                  })
                }
              </WarningsArea>
          ) : ''
        }
        <PeriodSection/>
        <LastConnectionSection
            rooms={rooms || []}
        />
      </Page>
  );

  //   return <div>Home! {auth.state.venue && auth.state.venue.name || 'ERROR'}</div>;
}
